import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {DynamicBarService} from '../../../_components/dynamic-bar/dynamic-bar.service';
import {Title} from '@angular/platform-browser';
import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  templateUrl: 'mapa-curricular.component.html',
  standalone: false,
  styleUrls: ['mapa-curricular.component.scss']
})

export class EstudioMapaCurricularComponent implements OnInit, OnDestroy {

  private cursosSubject = new Subject<any[]>();
  cursos$ = this.cursosSubject.asObservable();
  private areasSubject = new Subject<any[]>();
  areas$ = this.areasSubject.asObservable();
  private textFilterSubject = new BehaviorSubject('');
  textFilterAction$ = this.textFilterSubject.asObservable();

  fullData$ = combineLatest([
    this.cursos$,
    this.areas$,
    this.textFilterAction$
  ]).pipe(
    map(([cursos, areas, filterValue]) => {
      const cursosRet = JSON.parse(JSON.stringify(cursos.filter(curso => curso.nombre.toLowerCase().indexOf(filterValue) > -1))),
        rawAreas = JSON.parse(JSON.stringify(areas));
      let areasRet = rawAreas.filter(area => area.materias.some(materia => materia.nombre.toLowerCase().indexOf(filterValue) > -1));
      areasRet = areasRet.map((area, i) => {
          areasRet[i].materias = area.materias.filter(materia => materia.nombre.toLowerCase().indexOf(filterValue) > -1);
          return area;
        }
      );

      return {areas: areasRet, cursos: cursosRet};
    })
  );

  categoriasMetas: any[];

  constructor(private router: Router,
              private route: ActivatedRoute,
              private titleService: Title,
              private dynamicBarService: DynamicBarService) {
  }

  ngOnInit() {
    this.dynamicBarService.setBarra('estudio-mapa-curricular');
    this.titleService.setTitle('Mapa curricular - MiGLM');

    this.route.data
      .subscribe((
        data: {
          cursos: any[],
          areas: any[],
          categoriasMetas: any[]
        }
      ) => {
        this.cursosSubject.next(data.cursos);
        this.areasSubject.next(data.areas);
        this.categoriasMetas = data.categoriasMetas;
        this.categoriasMetas.map(val => val['visible'] = true);
      });

  }

  textFilter(value: string) {
    this.textFilterSubject.next(value.toLowerCase());
  }

  ngOnDestroy() {

  }

  abrirBusqueda() {
    // this.mapaCurricularService.abrirBusqueda();
    this.router.navigate([this.router.routerState.snapshot.url, {outlets: {'mc-sidebar': ['busqueda']}}], {
      skipLocationChange: true,
      relativeTo: this.route
    });
  }
}
